// SyntraMfgUpdates.jsx

import React from "react";

const updates = [
  {
    dateTime: "2025-04-12T10:00",
    title: "Launch of SyntraMfg Digital Manufacturing Hub",
    desc: "A one-stop digital platform for MSMEs, suppliers, distributors, and industries to connect directly."
  },
  {
    dateTime: "2025-04-10T14:30",
    title: "MoU Signed with National Small Industries Corporation (NSIC)",
    desc: "Partnership enables MSMEs to access SyntraMfg’s digital ecosystem for procurement and market linkages."
  },
  {
    dateTime: "2025-04-08T11:00",
    title: "Manufacturing Advisory Board Finalized",
    desc: "Experts from auto, textiles, steel, and electronics sectors join to guide SyntraMfg’s growth."
  },
  {
    dateTime: "2025-04-06T09:45",
    title: "Smart Factory Pilot",
    desc: "First rollout of IoT-enabled production monitoring and real-time efficiency tracking in partner factories."
  },
  {
    dateTime: "2025-04-04T17:15",
    title: "AI-driven Quality Control Demo",
    desc: "Manufacturers experienced SyntraMfg’s smart tools for defect detection and process optimization."
  },
  {
    dateTime: "2025-04-02T13:30",
    title: "Collaboration with Industrial Training Institutes (ITIs)",
    desc: "Partnership brings skill development and training services directly onto the SyntraMfg platform."
  },
  {
    dateTime: "2025-03-30T10:00",
    title: "Supplier Networks Onboarded",
    desc: "50+ suppliers from automotive, machinery, and consumer goods join SyntraMfg to expand digital reach."
  },
  {
    dateTime: "2025-03-28T16:00",
    title: "Beta Testing Begins",
    desc: "Early access to SyntraMfg’s B2B commerce and factory automation tools now open for select manufacturers."
  },
  {
    dateTime: "2025-03-25T12:00",
    title: "First Three Product Categories Listed",
    desc: "Industrial components, machinery spares, and consumer goods now available for procurement online."
  },
  {
    dateTime: "2025-03-22T18:30",
    title: "Vision, Mission, Values Published",
    desc: "Our commitment: Empower manufacturers, enable transparent supply chains, and deliver world-class quality to global markets."
  }
];

const SyntraMfgUpdates = () => {
  return (
    <section className="py-2 px-6 bg-gray-900 min-h-screen">
      <h2 className="text-xl lg:text-2xl font-bold text-center mb-12 text-yellow-300">
        SyntraMfg News & Updates
      </h2>
      <div className="mx-auto">
        {updates.map((update, idx) => (
          <div
            key={idx}
            className="bg-black text-white rounded-lg shadow-md p-5 hover:shadow-lg transition border border-cyan-600"
          >
            <div className="text-sm text-gray-400 mb-1">
              {new Date(update.dateTime).toLocaleString("en-IN", {
                dateStyle: "medium",
                timeStyle: "short"
              })}
            </div>
            <h3 className="text-sm lg:text-lg text-yellow-200">
              {update.title}
            </h3>
            <p className="text-gray-200 text-sm lg:text-m mt-1">{update.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SyntraMfgUpdates;
